import { HorseType } from '@/utils/horseType'
import { DocumentType } from '@/utils/documentTypes'

export type DocumentRuleType = 'COMPULSORY' | 'COMPULSORY_IF_FG_CONTRACT' | 'COMPULSORY_IF_TROT_AND_CONTRACT' | 'COMPULSORY_IF_COVERED' | 'OPTIONAL_IF_FEMALE' | 'OPTIONAL_IF_MALE' | 'OPTIONAL'

export const documentsRuleOnline: Partial<Record<HorseType, Partial<Record<DocumentType, DocumentRuleType>>>> = {
  'CAE': {
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'PRE_SALE_CERTIFICATE': 'COMPULSORY',
  },
  'MARE': {
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'PRE_SALE_CERTIFICATE': 'COMPULSORY',
  },
  'STORE2': {
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'PRE_SALE_CERTIFICATE': 'COMPULSORY',
  },
  'YEAR2': {
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'PRE_SALE_CERTIFICATE': 'COMPULSORY',
  },
  'FOAL': {
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'PRE_SALE_CERTIFICATE': 'COMPULSORY',
  },
  'STALLION': {
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'PRE_SALE_CERTIFICATE': 'COMPULSORY',
  },
  'STORE3': {
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'PRE_SALE_CERTIFICATE': 'COMPULSORY',
  },
  'MAIDEN': {
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'PRE_SALE_CERTIFICATE': 'COMPULSORY',
  },
  'YEARLING': {
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'PRE_SALE_CERTIFICATE': 'COMPULSORY',
  },
  'STALLION_PART': {
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'PRE_SALE_CERTIFICATE': 'COMPULSORY',
  },
  'BREEDING_RIGHT': {
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'PRE_SALE_CERTIFICATE': 'COMPULSORY',
  },
}
